import { PROFILES_PATH } from '../../constants'
import getCurrentReduxSelector from '../../../../redux/selectors/get-current'

export const getCurrentProfileSelect = getCurrentReduxSelector(
  PROFILES_PATH.DATA,
  PROFILES_PATH.CURRENT
)
